 const array_of_params = ["projects","finished-projects","cases", "persons", "institutions"]

 const handlePageLoad = (listType)=> {
      return JSON.parse(localStorage.getItem(`${listType}QueryParams`));
  }


  const clearAllParams= ()=> {
    array_of_params.forEach(p => localStorage.removeItem(`${p}QueryParams`))
}


  const storeQueryParams = (listType,storeData)=> {
    localStorage.setItem(`${listType}QueryParams`, JSON.stringify(storeData));
    return storeData
  }
  export {handlePageLoad,storeQueryParams,clearAllParams}